import React, { createContext, useContext, useState, useEffect } from "react";
import { translations } from "@/data/translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    return localStorage.getItem("gupta_lang") || "en";
  });

  const setLang = (newLang) => {
    setLangState(newLang);
    localStorage.setItem("gupta_lang", newLang);
  };

  useEffect(() => {
    if (lang === "te") {
      document.body.classList.add("lang-te");
    } else {
      document.body.classList.remove("lang-te");
    }
  }, [lang]);

  // Helper function to resolve nested keys like "hero.headlineLine1"
  const t = (path) => {
    const keys = path.split(".");
    let current = translations[lang] || translations["en"];
    for (const key of keys) {
      if (current && current[key] !== undefined) {
        current = current[key];
      } else {
        // Fallback to English if key missing in target language
        let fallback = translations["en"];
        for (const k of keys) {
          fallback = fallback?.[k];
        }
        return fallback || path;
      }
    }
    return current;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
